import TsaHandlerVerifySuccess from '@/components/handlerVerifySuccess/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const HandlerVerifySucess = vue.extend(TsaHandlerVerifySuccess)
    if (!$vm) {
      $vm = new HandlerVerifySucess({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const handlerVerifySucess = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaHandlerVerifySuccess) {
      vue.prototype.$TsaHandlerVerifySuccess = handlerVerifySucess
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/handlerVerifySuccess/index.js